import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { TeamSection } from '../components/TeamSection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-169">
      <Navbar data-id="element-170" />
      <main data-id="element-171">
        <Hero data-id="element-172" />
        <AboutSection data-id="element-173" />
        <ServicesSection data-id="element-174" />
        <TeamSection data-id="element-175" />

        {/* Simple Contact CTA Section */}
        <section id="contact" className="py-20 bg-[#4CAF50] relative overflow-hidden scroll-mt-24" data-id="element-176">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-177"></div>
          <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-178">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-179">
              Ready to Spark Your Growth?
            </h2>
            <p className="text-xl text-green-50 mb-10 max-w-2xl mx-auto" data-id="element-180">
              Let's discuss how we can help your brand connect with the right
              audience and achieve measurable results.
            </p>
            <a href="mailto:hello@flickerdigital.africa" className="inline-block px-8 py-4 bg-white text-[#4CAF50] font-bold rounded-full hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-181">
              Start a Project
            </a>
          </div>
        </section>
      </main>
      <Footer data-id="element-182" />
    </div>;
}